import { FixturePage } from '@cds/betting-offer';
import { SportModel } from '@frontend/sports/betting-offer/feature/model';
import { CountItem, LeagueItem } from '@frontend/sports/common/core/data-access/sport-model';
import { GridSorting } from '@frontend/sports/grid/core/feature/model';

export enum CouponType {
    BetBuilder = -1,
    MultiBuilder,
    Regular,
    FormCoupon,
}

export interface Coupon {
    id: number;
    title: string;
    description: string;
    active?: boolean;
    type: CouponType;
    gridGroups?: string[];
    landingPageImageUrl?: string;
    detailsPageImageUrl?: string;
    bgColor?: string;
    textColor?: string;
    order?: number;
    isFormCoupon: boolean;
    couponType?: string;
    showMarketSwitcher?: boolean;
    sortByPrice?: boolean;
    couponTag?: string;
    offerSelection?: string;
}

export interface CouponList {
    coupons: Coupon[];
    sport: SportModel;
    counts?: CountItem;
}

export interface CouponDetail extends Coupon {
    sport: SportModel;
    sorting?: GridSorting;
    page: FixturePage;
    competition?: number;
    virtualCompetitionData?: LeagueItem;
}
